<template>
  <div class="ele-body">
    <el-card shadow="never">
      <!-- 操作按钮 -->
      <div class="ele-table-tool ele-table-tool-default">
        <el-button @click="add" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small">添加 </el-button>
      </div>
      <!-- 数据表格 -->
      <ele-data-table ref="table" :config="table" :choose.sync="choose" highlight-current-row>
        <template #default="{ index }">
          <el-table-column type="selection" width="45" align="center" fixed="left" />
          <el-table-column type="index" :index="index" width="45" align="center" fixed="left" show-overflow-tooltip />
          <el-table-column prop="startTime" label="开始时间" sortable="custom" show-overflow-tooltip min-width="110" />
          <el-table-column prop="endTime" label="结束时间" sortable="custom" show-overflow-tooltip min-width="110" />
          <el-table-column prop="createTime" label="创建时间" show-overflow-tooltip min-width="110" />
          <el-table-column label="操作" width="130px" align="center" :resizable="false">
            <template #default="{ row }">
              <el-link @click="edit(row)" icon="el-icon-edit" type="primary" :underline="false">修改</el-link>
              <el-popconfirm title="确定要删除此数据吗？" @onConfirm="remove(row)" class="ele-action">
                <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false">删除</el-link>
              </el-popconfirm>
            </template>
          </el-table-column>
        </template>
      </ele-data-table>
    </el-card>
    <!-- 编辑弹窗 -->
    <el-dialog
      :title="editForm.id ? '修改用户' : '添加用户'"
      :visible.sync="showEdit"
      width="400px"
      @closed="editForm = {}"
      :destroy-on-close="true"
      custom-class="ele-dialog-form"
      :lock-scroll="false"
    >
      <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="85px">
        <el-row :gutter="15">
          <el-col>
            <el-form-item label="开始时间:" prop="startTime">
              <el-time-picker placeholder="开始时间" format="HH:mm" value-format="HH:mm" v-model="editForm.startTime"> </el-time-picker>
            </el-form-item>
            <el-form-item label="结束时间:" prop="endTime">
              <el-time-picker placeholder="结束时间" format="HH:mm" value-format="HH:mm" v-model="editForm.endTime"> </el-time-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button @click="showEdit = false">取消</el-button>
        <el-button type="primary" @click="save(editForm.id)">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { delAccessLate, saveAccessLate } from '@/config/api'; //修改角色权限

  export default {
    name: 'Behavior',
    data() {
      return {
        table: {
          // 表格配置
          url: '/studentLate/lateList',
          where: {},
          page: false,
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            return res;
          },
        },
        choose: [], // 表格选中数据
        showEdit: false, // 是否显示表单弹窗
        editForm: {}, // 表单数据
        editRules: {
          // 表单验证规则
          startTime: [{ required: true, message: '请选择开始时间', trigger: 'change' }],
          endTime: [{ required: true, message: '请选择结束时间', trigger: 'change' }],
        },
      };
    },
    mounted() {},
    methods: {
      // 显示添加
      add() {
        this.showEdit = true;
      },
      /* 显示编辑 */
      edit(row) {
        this.editForm = Object.assign({}, row, {});
        this.showEdit = true;
      },
      /* 保存编辑 */
      save(userId) {
        this.$refs['editForm'].validate((valid) => {
          if (valid) {
            const loading = this.$loading({ lock: true });
            let formData = new FormData();
            for (let key in this.editForm) {
              if (this.editForm[key] !== null && this.editForm[key] !== undefined) {
                formData.append(key, this.editForm[key]);
              }
            }
            saveAccessLate(formData)
              .then((res) => {
                loading.close();
                if (res.data.resCode == 200) {
                  this.showEdit = false;
                  this.$message({ type: 'success', message: res.data.resMsg });
                  this.$refs.table.reload();
                } else {
                  this.$message.error(res.data.resMsg);
                }
              })
              .catch((e) => {
                loading.close();
                this.$message.error(e.message);
              });
          } else {
            return false;
          }
        });
      },
      /* 删除 */
      remove(row) {
        const loading = this.$loading({ lock: true });
        let formData = new FormData();
        formData.append('id', row.id);
        delAccessLate(formData)
          .then((res) => {
            loading.close();
            if (res.data.resCode == 200) {
              this.$message({ type: 'success', message: res.data.resMsg });
              this.$refs.table.reload();
            } else {
              this.$message.error(res.data.resMsg);
            }
          })
          .catch((e) => {
            loading.close();
            this.$message.error(e.message);
          });
      },
    },
  };
</script>

<style scoped>
  .ele-block >>> .el-upload,
  .ele-block >>> .el-upload-dragger {
    width: 100%;
  }
  .org-tree-group {
    border: 1px solid hsla(0, 0%, 60%, 0.15);
    /*height: calc(100vh - 262px);*/
    height: 55vh;
    box-sizing: border-box;
    overflow-x: auto;
  }

  .org-tree-group >>> .el-tree-node__content {
    height: 40px;
  }

  .org-tree-group >>> .el-tree-node__content > .el-tree-node__expand-icon {
    margin-left: 10px;
  }
</style>
